/**
 * @file Creates mobile search slideout functionality.
 */
(function($, Drupal) {
  Drupal.behaviors.boemMobileSearch = {
    attach: function(context, settings) {
      once('boemMobileSearch', 'button.js-search-toggle').forEach(function (element) {
        var $searchToggle = $($(element), context);
        var $mobileSearchBlock = $('.l-page__navigation-mobile-search .boem-site-search', context);
        $searchToggle.click(function() {
          $mobileSearchBlock.toggleClass('show');
        });
      })
    }
  };
})(jQuery, Drupal);
